webpackJsonp([277288064929247],{

/***/ 169:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 290:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _HomeLayout = __webpack_require__(310);
	
	var _HomeLayout2 = _interopRequireDefault(_HomeLayout);
	
	var _layoutHomeLayout = __webpack_require__(169);
	
	var _layoutHomeLayout2 = _interopRequireDefault(_layoutHomeLayout);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_HomeLayout2.default, _extends({}, props, _layoutHomeLayout2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 69:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _config = __webpack_require__(17);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _FooterStyles = __webpack_require__(70);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Footer = function Footer(_ref) {
	  var light = _ref.light;
	  return _react2.default.createElement(
	    _FooterStyles.FooterWrap,
	    null,
	    _react2.default.createElement(
	      _FooterStyles.ContentSection,
	      null,
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h5',
	          null,
	          'Quick Links'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/' },
	            'Home'
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/foods' },
	            'Foods'
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/nutrients' },
	            'Nutrients & Vitamins'
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/diets' },
	            'Diets'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h5',
	          null,
	          'Social'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Twitter'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h5',
	          null,
	          'About'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/jamstack/tools/' },
	            'How was this site built?'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h5',
	          null,
	          'Legal'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/privacy' },
	            'Privacy Policy'
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          '\xA9 toomanykiwis.com ',
	          new Date().getFullYear()
	        )
	      )
	    )
	  );
	};
	
	// Styles
	
	
	Footer.propsTypes = {};
	
	Footer.defaultProps = {};
	
	exports.default = Footer;
	module.exports = exports['default'];

/***/ }),

/***/ 70:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ContentSection = exports.FooterWrap = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  background: rgb(10, 10, 10);\n  color: white;\n  padding: 2rem 0;\n'], ['\n  background: rgb(10, 10, 10);\n  color: white;\n  padding: 2rem 0;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  height: 100%;\n  width: 100%;\n  display: grid;\n  grid-template-columns: 50% 50%;\n  ', '\n  ', '\n  ', '\n  grid-auto-rows: 1fr;\n\n  > div {\n    display: block;\n    padding: 1rem;\n    margin: 1rem;\n    min-height: 100px;\n\n    p {\n      margin: 1rem 0;\n    }\n\n    a {\n      color: rgba(255, 255, 255, 0.85);\n      text-decoration: none;\n    }\n  }\n'], ['\n  height: 100%;\n  width: 100%;\n  display: grid;\n  grid-template-columns: 50% 50%;\n  ', '\n  ', '\n  ', '\n  grid-auto-rows: 1fr;\n\n  > div {\n    display: block;\n    padding: 1rem;\n    margin: 1rem;\n    min-height: 100px;\n\n    p {\n      margin: 1rem 0;\n    }\n\n    a {\n      color: rgba(255, 255, 255, 0.85);\n      text-decoration: none;\n    }\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['grid-template-columns: 50% 50%;'], ['grid-template-columns: 50% 50%;']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['grid-template-columns: 25% 25% 25% 25%;'], ['grid-template-columns: 25% 25% 25% 25%;']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['grid-template-columns: 20% 20% 20% 20% 20%;'], ['grid-template-columns: 20% 20% 20% 20% 20%;']);
	
	var _styledComponents = __webpack_require__(7);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _styleUtils = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var FooterWrap = exports.FooterWrap = _styledComponents2.default.footer(_templateObject);
	
	var ContentSection = exports.ContentSection = _styledComponents2.default.section(_templateObject2, _styleUtils.media.fromSmall(_templateObject3), _styleUtils.media.fromMedium(_templateObject4), _styleUtils.media.fromLarge(_templateObject5));

/***/ }),

/***/ 71:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Footer = __webpack_require__(69);
	
	var _Footer2 = _interopRequireDefault(_Footer);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _Footer2.default;
	module.exports = exports['default'];

/***/ }),

/***/ 43:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _config = __webpack_require__(17);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _Search = __webpack_require__(78);
	
	var _Search2 = _interopRequireDefault(_Search);
	
	var _Logo = __webpack_require__(37);
	
	var _Logo2 = _interopRequireDefault(_Logo);
	
	var _HeaderStyles = __webpack_require__(44);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Header = function Header(_ref) {
	  var light = _ref.light;
	  return _react2.default.createElement(
	    _HeaderStyles.StyledHeader,
	    null,
	    !light && _react2.default.createElement(
	      _HeaderStyles.HeadingWrap,
	      null,
	      _react2.default.createElement(
	        _HeaderStyles.Heading,
	        null,
	        _react2.default.createElement(_Logo2.default, { size: 32 }),
	        'toomanykiwis'
	      ),
	      _react2.default.createElement(
	        _HeaderStyles.TagLine,
	        null,
	        _config2.default.TAG_LINE
	      )
	    ),
	    _react2.default.createElement(_Search2.default, null)
	  );
	};
	
	// Components
	
	
	Header.propsTypes = {
	  light: _propTypes2.default.bool
	};
	
	Header.defaultProps = {
	  light: true
	};
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),

/***/ 44:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.HeadingWrap = exports.TagLine = exports.Heading = exports.StyledHeader = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  width: 100%;\n  padding: 1rem 2rem;\n  position: relative;\n'], ['\n  width: 100%;\n  padding: 1rem 2rem;\n  position: relative;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  justify-content: flex-start;\n  display: flex;\n  align-items: center;\n  font-size: 4rem;\n\n  > span {\n    font-size: 2rem;\n    position: relative;\n    top: 6px;\n    left: 1px;\n  }\n\n  > div {\n    margin: 0 8px 0 0;\n    display: inline-block;\n    position: relative;\n\n    > svg {\n      position: absolute;\n      top: 0;\n      left: 0;\n    }\n  }\n'], ['\n  justify-content: flex-start;\n  display: flex;\n  align-items: center;\n  font-size: 4rem;\n\n  > span {\n    font-size: 2rem;\n    position: relative;\n    top: 6px;\n    left: 1px;\n  }\n\n  > div {\n    margin: 0 8px 0 0;\n    display: inline-block;\n    position: relative;\n\n    > svg {\n      position: absolute;\n      top: 0;\n      left: 0;\n    }\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  margin: 0 0 0 3.9rem;\n'], ['\n  margin: 0 0 0 3.9rem;\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  padding: 1rem 0 2rem;\n'], ['\n  padding: 1rem 0 2rem;\n']);
	
	var _styledComponents = __webpack_require__(7);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var StyledHeader = exports.StyledHeader = _styledComponents2.default.header(_templateObject);
	
	var Heading = exports.Heading = _styledComponents2.default.h1(_templateObject2);
	
	var TagLine = exports.TagLine = _styledComponents2.default.p(_templateObject3);
	
	var HeadingWrap = exports.HeadingWrap = _styledComponents2.default.hgroup(_templateObject4);

/***/ }),

/***/ 45:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Header = __webpack_require__(43);
	
	var _Header2 = _interopRequireDefault(_Header);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _Header2.default;
	module.exports = exports['default'];

/***/ }),

/***/ 310:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  padding: 1rem 2rem;\n'], ['\n  padding: 1rem 2rem;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  padding: 0;\n  margin: 0;\n  background: white;\n'], ['\n  padding: 0;\n  margin: 0;\n  background: white;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(7);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactHelmet = __webpack_require__(33);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _config = __webpack_require__(17);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _Header = __webpack_require__(45);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(71);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	__webpack_require__(80);
	
	__webpack_require__(91);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	// Components
	
	
	// Styles
	
	
	var StyledContentSection = _styledComponents2.default.div(_templateObject);
	
	var StyledWrapper = _styledComponents2.default.div(_templateObject2);
	
	var HomeLayout = function HomeLayout(props) {
	  var children = props.children;
	
	  return _react2.default.createElement(
	    StyledWrapper,
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      {
	        defaultTitle: _config2.default.APP_NAME,
	        titleTemplate: '%s | ' + _config2.default.APP_NAME },
	      _react2.default.createElement('link', { rel: 'icon', type: 'image/png', href: (0, _gatsbyLink.withPrefix)('/images/favicon-32x32.png'), sizes: '32x32' }),
	      _react2.default.createElement('link', { rel: 'icon', type: 'image/png', href: (0, _gatsbyLink.withPrefix)('/images/favicon-16x16.png'), sizes: '16x16' })
	    ),
	    _react2.default.createElement(_Header2.default, { light: false }),
	    _react2.default.createElement(
	      StyledContentSection,
	      null,
	      children()
	    ),
	    _react2.default.createElement(_Footer2.default, null)
	  );
	};
	
	HomeLayout.propTypes = {
	  children: _propTypes2.default.any
	};
	
	exports.default = HomeLayout;
	module.exports = exports['default'];

/***/ }),

/***/ 79:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _CatamaranLight300Latin = __webpack_require__(93);
	
	var _CatamaranLight300Latin2 = _interopRequireDefault(_CatamaranLight300Latin);
	
	var _CatamaranLight300LatinExt = __webpack_require__(94);
	
	var _CatamaranLight300LatinExt2 = _interopRequireDefault(_CatamaranLight300LatinExt);
	
	var _CatamaranThin100Latin = __webpack_require__(95);
	
	var _CatamaranThin100Latin2 = _interopRequireDefault(_CatamaranThin100Latin);
	
	var _CatamaranThin100LatinExt = __webpack_require__(96);
	
	var _CatamaranThin100LatinExt2 = _interopRequireDefault(_CatamaranThin100LatinExt);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  CatamaranLight300Latin: _CatamaranLight300Latin2.default,
	  CatamaranLight300LatinExt: _CatamaranLight300LatinExt2.default,
	  CatamaranThin100Latin: _CatamaranThin100Latin2.default,
	  CatamaranThin100LatinExt: _CatamaranThin100LatinExt2.default
	};
	module.exports = exports['default'];

/***/ }),

/***/ 93:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/CatamaranLight300Latin.89eeec98.woff2";

/***/ }),

/***/ 94:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/CatamaranLight300LatinExt.0e9b0617.woff2";

/***/ }),

/***/ 95:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/CatamaranThin100Latin.8e9c9a34.woff2";

/***/ }),

/***/ 96:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/CatamaranThin100LatinExt.a461d3f3.woff2";

/***/ }),

/***/ 80:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  /* latin-ext */\n  @font-face {\n    font-family: \'Catamaran\';\n    font-style: normal;\n    font-weight: 100;\n    src: local(\'Catamaran Thin\'), local(\'Catamaran-Thin\'), url(', ') format(\'woff2\');\n    unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;\n  }\n  /* latin */\n  @font-face {\n    font-family: \'Catamaran\';\n    font-style: normal;\n    font-weight: 100;\n    src: local(\'Catamaran Thin\'), local(\'Catamaran-Thin\'), url(', ') format(\'woff2\');\n    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;\n  }\n  /* latin-ext */\n  @font-face {\n    font-family: \'Catamaran\';\n    font-style: normal;\n    font-weight: 300;\n    src: local(\'Catamaran Light\'), local(\'Catamaran-Light\'), url(', ') format(\'woff2\');\n    unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;\n  }\n  /* latin */\n  @font-face {\n    font-family: \'Catamaran\';\n    font-style: normal;\n    font-weight: 300;\n    src: local(\'Catamaran Light\'), local(\'Catamaran-Light\'), url(', ') format(\'woff2\');\n    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;\n  }\n'], ['\n  /* latin-ext */\n  @font-face {\n    font-family: \'Catamaran\';\n    font-style: normal;\n    font-weight: 100;\n    src: local(\'Catamaran Thin\'), local(\'Catamaran-Thin\'), url(', ') format(\'woff2\');\n    unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;\n  }\n  /* latin */\n  @font-face {\n    font-family: \'Catamaran\';\n    font-style: normal;\n    font-weight: 100;\n    src: local(\'Catamaran Thin\'), local(\'Catamaran-Thin\'), url(', ') format(\'woff2\');\n    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;\n  }\n  /* latin-ext */\n  @font-face {\n    font-family: \'Catamaran\';\n    font-style: normal;\n    font-weight: 300;\n    src: local(\'Catamaran Light\'), local(\'Catamaran-Light\'), url(', ') format(\'woff2\');\n    unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;\n  }\n  /* latin */\n  @font-face {\n    font-family: \'Catamaran\';\n    font-style: normal;\n    font-weight: 300;\n    src: local(\'Catamaran Light\'), local(\'Catamaran-Light\'), url(', ') format(\'woff2\');\n    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;\n  }\n']);
	
	var _styledComponents = __webpack_require__(7);
	
	var _fonts = __webpack_require__(79);
	
	var _fonts2 = _interopRequireDefault(_fonts);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	// inject font files so they get inlined in the bundle via webpack
	exports.default = (0, _styledComponents.injectGlobal)(_templateObject, _fonts2.default.CatamaranThin100LatinExt, _fonts2.default.CatamaranThin100Latin, _fonts2.default.CatamaranLight300LatinExt, _fonts2.default.CatamaranLight300Latin);
	module.exports = exports['default'];

/***/ }),

/***/ 91:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-home-layout-jsx-74664aec41f80503e641.js